import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgAssignmentThin = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-.5 -.5 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M2.875 20.125V2.875h6.349q.1197-.8385.7666-1.3776.647-.539 1.5094-.539t1.5094.539q.6469.5391.7666 1.3776h6.349v17.25zm1.4375-1.4375h14.375V4.3125H4.3125zm2.3958-2.3958h6.5407v-1.4375H6.7083zm0-4.073h9.5834v-1.4375H6.7083zm0-4.0729h9.5834V6.7083H6.7083zM11.5 3.9052q.3354 0 .587-.2516t.2515-.587q0-.3353-.2515-.587-.2516-.2515-.587-.2515t-.587.2516-.2515.587.2515.587q.2516.2515.587.2515"
    />
  </svg>
);
export default SvgAssignmentThin;
